import React from 'react';
import styles from './PageHeaderPlaceholder.module.scss';
import DefaultPlaceholder from '../../LoadingPlaceholder/DefaultPlaceholder';
var length = [30, 60];
export default function HeaderPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement(DefaultPlaceholder, {
    id: "header-placeholder",
    rows: 1,
    length: length
  }));
}